'use client'
import { useLocale, useTranslations } from 'next-intl'
import { addOrReplaceLocaleInUrl } from 'cf-i18n/helpers'
import { Link } from '@repo/web-ui/components/link'

import { Rating } from '../rating/rating'
import { VerfiedCheck } from '../../icons/verfied-check'
import { ReplyButton } from './reply'
import { UserAvatar } from '../favorites/avatars'
import * as ExpandableView from '@web/components/expandable-view'

interface SingleReviewProps extends React.HTMLProps<HTMLDivElement> {
  user: {
    name: string
    initials: string
    avatarUrl?: string
    crafterUrl?: string
  }
  rating: number
  date: string
  reviewText: string
}

export function SingleReview({ user, rating, date, reviewText, children }: SingleReviewProps) {
  const t = useTranslations('prod.product_description_page.reviews')
  // const { isLoading, data: userData } = useUserQuery(undefined, {
  //   select: data => data?.me?.user,
  // })
  const showReply = false //!isLoading && !!userData?.capabilities.includes('dashboard_reviews')
  const locale = useLocale()
  const crafterUrl = addOrReplaceLocaleInUrl(
    user.crafterUrl?.endsWith('/') ? user.crafterUrl : `${user.crafterUrl ?? ''}/`,
    locale,
  )

  return (
    <div className="border-cf-dreamy-cloud-600 flex flex-row gap-3 border-b py-6">
      <UserAvatar
        avatarUrl={user.avatarUrl}
        initials={user.initials}
        className="relative"
        crafterUrl={crafterUrl}
      />
      <div className="flex w-full flex-row flex-wrap items-start justify-between gap-2 text-[14px]">
        <div className="mb-1 flex flex-col items-start gap-2 min-[600px]:flex-row min-[600px]:items-center">
          <Link href={crafterUrl} target="_blank" component="a" className="mr-4 font-bold">
            {user.name}
          </Link>
          <span className="inline-flex gap-1 whitespace-nowrap">
            <VerfiedCheck className="mr-1 text-[#647FCC]" />
            {t('verified_purchaser')}
          </span>
        </div>
        <div className="mb-1 flex items-center gap-2">
          <div className="">{date}</div>
          <Rating value={rating} readOnly className="ml-0 h-6" />
        </div>
        <ExpandableView.Root className="grow-1 w-full">
          <ExpandableView.Content>{reviewText}</ExpandableView.Content>
          <ExpandableView.TriggerButton
            className="py-0"
            showMoreText={t('read_more')}
            showLessText={t('read_less')}
            showIcon
          />
        </ExpandableView.Root>
        {showReply ? <ReplyButton /> : null}
      </div>
      {children}
    </div>
  )
}
